import {useQuery} from '@tanstack/react-query';
import {CloudApi} from 'app/components/entities/cloud/api/CloudApi';
import {cloudMapper} from 'app/components/entities/cloud/model';

interface Args {
  teamId: string;
}

export function usePairedStatsQuery({teamId}: Args) {
  return useQuery({
    queryKey: ['cloud', 'paired', teamId],
    queryFn: async () => {
      const res = await CloudApi.getPairingStats(teamId);
      return cloudMapper.mapPairingStats(res);
    },
  });
}
